import { Trans, useLingui } from '@lingui/react/macro';

import { TranslatableInputText } from '@/design_system/InputText';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';

import { type ConditionFormQuestion } from './ConditionQuestion';

export type IMultiQuantifiableSelectConfig = Extract<
  ConditionFormQuestion['config'],
  { addButton: any }
>;

export const MultiQuantifiableSelectConfig = ({
  config,
  onChange,
}: {
  config: IMultiQuantifiableSelectConfig;
  onChange: (config: IMultiQuantifiableSelectConfig) => void;
}) => {
  const { t } = useLingui();

  return (
    <Stack gap="0.5rem">
      <Stack gap="0.25rem">
        <Paragraph weight="medium">
          <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.multi-quantifiable-select.add-button-label">
            "Add option" label:
          </Trans>
        </Paragraph>
        <TranslatableInputText
          size="small"
          value={config.addButton?.label ?? { en: '', fr: '' }}
          onChange={(label) => onChange({ ...config, addButton: { ...config.addButton, label } })}
          aria-label={t({
            id: 'settings.organization.data-catalogs.condition-forms.detail.question.multi-quantifiable-select.add-button-label.aria',
            message: 'Add option label',
          })}
          placeholder={t({
            id: 'settings.organization.data-catalogs.condition-forms.detail.question.multi-quantifiable-select.add-button-label.placeholder',
            message: 'Label of the "Add option" button',
          })}
        />
      </Stack>
      <Stack gap="0.25rem">
        <Paragraph weight="medium">
          <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.multi-quantifiable-select.select-placeholder">
            "Select option" placeholder:
          </Trans>
        </Paragraph>
        <TranslatableInputText
          size="small"
          value={config.select?.placeholder ?? { en: '', fr: '' }}
          onChange={(placeholder) =>
            onChange({ ...config, select: { ...config.select, placeholder } })
          }
          aria-label={t({
            id: 'settings.organization.data-catalogs.condition-forms.detail.question.multi-quantifiable-select.select-placeholder.aria',
            message: 'Select option placeholder',
          })}
          placeholder={t({
            id: 'settings.organization.data-catalogs.condition-forms.detail.question.multi-quantifiable-select.select-placeholder.placeholder',
            message: 'Placeholder of the "Select option" input',
          })}
        />
      </Stack>
    </Stack>
  );
};
